import { RestSchemas } from '@/contexts/QueryProvider'

export type PlatformMarketingCard = RestSchemas['Messages.Landing.PlatformMarketingCard']

const STEP_NUMBER = /step\s+(\d+)/i
const STEP_PREFIX = /^step\s+\d+\s*[-–—:]\s*/i

function hasGrouping(item: PlatformMarketingCard, value: string) {
  return item.card.groupings.some((grouping) => grouping.value === value)
}

function stepNumber(title: string) {
  const match = title.match(STEP_NUMBER)
  return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER
}

export function stepLabel(title: string) {
  const stripped = title.replace(STEP_PREFIX, '').trim()
  return stripped || title
}

export function groupPlatformItems(items: PlatformMarketingCard[]) {
  const getStarted = items.filter((item) => hasGrouping(item, 'Get started'))

  return {
    benefits: items.filter((item) => hasGrouping(item, 'Benefits')),
    ourEdge: items.filter((item) => hasGrouping(item, 'Our edge')),
    getStarted: [...getStarted].sort((a, b) => stepNumber(a.card.title) - stepNumber(b.card.title)),
    terminology: items.filter((item) => hasGrouping(item, 'Terminology')),
    contacts: items.filter((item) => hasGrouping(item, 'Get in touch')),
  }
}
